import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.53 3.118a1 1 0 0 1 .94 0l15 8a1 1 0 0 1 0 1.764l-2.97 1.585v6.225a1.98 1.98 0 0 1-.401 1.184c-.466.625-1.638 2.014-3.599 3.255V30a1 1 0 1 1-2 0v-3.808c-1.744.762-3.9 1.308-6.5 1.308-7.349 0-11.16-4.364-12.099-5.624-.258-.34-.4-.756-.401-1.184v-6.225L.53 12.882a1 1 0 0 1 0-1.764zM5.045 13.024q-.074-.048-.155-.082L3.125 12 16 5.133 28.875 12l-1.766.942q-.081.034-.155.082L23.5 14.867l-7.03-3.75a1 1 0 1 0-.94 1.765L21.374 16 16 18.867zm.454 2.51v5.14l.002.004C6.244 21.674 9.532 25.5 16 25.5c2.709 0 4.86-.671 6.5-1.524v-6.31l-6.03 3.216a1 1 0 0 1-.94 0zm19 7.152c1.06-.835 1.715-1.628 1.998-2.008l.002-.003v-5.142l-2 1.067z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconLearningAcademy = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLearningAcademy);
export default Memo;
